// ─── CLV Tracker ─────────────────────────────────────────────────────────────
import { useState, useEffect } from "react";
import { apiFetch } from "../App";

// ─── Tipster Hub ──────────────────────────────────────────────────────────────
export function TipsterHub() {
  const [tipsters, setTipsters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [sort, setSort] = useState("roi");

  useEffect(() => {
    apiFetch(`/tipsters?sortBy=${sort}&limit=20`)
      .then(d => setTipsters(d.tipsters || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [sort]);

  const viewTipster = async (id) => {
    setSelected(id);
    const data = await apiFetch(`/tipsters/${id}`);
    setSelectedData(data);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontSize: 13, color: "var(--text3)" }}>All stats verified by OddsEdge BW — no self-reporting</div>
        <div style={{ display: "flex", gap: 6 }}>
          {["roi", "winRate", "avgClv"].map(s => (
            <button key={s} className={`btn ${sort === s ? "btn-primary" : "btn-ghost"}`} style={{ fontSize: 12, padding: "6px 14px" }} onClick={() => setSort(s)}>
              {s === "roi" ? "ROI" : s === "winRate" ? "Win Rate" : "CLV"}
            </button>
          ))}
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: selected ? "1fr 380px" : "1fr", gap: 16, alignItems: "start" }}>
        <div className="card">
          {loading ? (
            <div style={{ padding: 20 }}>{[...Array(5)].map((_, i) => <div key={i} className="skeleton" style={{ height: 64, marginBottom: 10 }} />)}</div>
          ) : tipsters.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">🏆</div>
              <p>No tipsters yet. Be the first!</p>
              <p style={{ marginTop: 8, fontSize: 12 }}>Track 50 bets via CLV Tracker, then apply.</p>
            </div>
          ) : (
            <table className="data-table">
              <thead><tr><th>#</th><th>Tipster</th><th style={{ textAlign: "center" }}>Bets</th><th style={{ textAlign: "center" }}>Win %</th><th style={{ textAlign: "center" }}>ROI</th><th style={{ textAlign: "center" }}>CLV</th><th></th></tr></thead>
              <tbody>
                {tipsters.map((t, i) => (
                  <tr key={t._id} onClick={() => viewTipster(t._id)}>
                    <td><span style={{ fontFamily: "var(--font-display)", fontWeight: 700, color: i === 0 ? "var(--accent3)" : i === 1 ? "var(--text2)" : "var(--text3)" }}>{i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : i + 1}</span></td>
                    <td>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div style={{ width: 32, height: 32, borderRadius: "50%", background: "rgba(0,229,176,0.12)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 13, color: "var(--accent)", flexShrink: 0 }}>
                          {t.name?.slice(0, 2).toUpperCase()}
                        </div>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: 13 }}>{t.name}</div>
                          <div style={{ fontSize: 10, color: "var(--text3)" }}>{t.preferredSports?.join(", ") || "All sports"}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ textAlign: "center", fontSize: 13 }}>{t.totalBets}</td>
                    <td style={{ textAlign: "center", fontFamily: "var(--font-display)", fontWeight: 600 }}>{t.winRate}%</td>
                    <td style={{ textAlign: "center" }}>
                      <span style={{ fontFamily: "var(--font-display)", fontWeight: 700, color: t.roi >= 0 ? "var(--success)" : "var(--danger)" }}>
                        {t.roi >= 0 ? "+" : ""}{t.roi}%
                      </span>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <span style={{ fontFamily: "var(--font-display)", fontWeight: 700, color: t.avgClv >= 0 ? "var(--success)" : "var(--danger)", fontSize: 12 }}>
                        {t.avgClv >= 0 ? "+" : ""}{t.avgClv}%
                      </span>
                    </td>
                    <td style={{ textAlign: "right" }}>
                      <span className="pill pill-teal" style={{ fontSize: 10, cursor: "pointer" }}>Follow</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {selected && selectedData && (
          <div className="card" style={{ position: "sticky", top: 80 }}>
            <div className="section-header">
              <div className="section-title">{selectedData.tipster?.name}</div>
              <button onClick={() => { setSelected(null); setSelectedData(null); }} style={{ color: "var(--text3)", fontSize: 18 }}>✕</button>
            </div>
            <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 14 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                {[
                  { label: "Bets tracked", value: selectedData.tipster?.totalBets },
                  { label: "Win rate", value: `${selectedData.tipster?.winRate}%` },
                  { label: "ROI", value: `${selectedData.tipster?.roi >= 0 ? "+" : ""}${selectedData.tipster?.roi}%`, color: selectedData.tipster?.roi >= 0 ? "var(--success)" : "var(--danger)" },
                  { label: "Avg CLV", value: `${selectedData.tipster?.avgClv >= 0 ? "+" : ""}${selectedData.tipster?.avgClv}%`, color: selectedData.tipster?.avgClv >= 0 ? "var(--success)" : "var(--danger)" },
                ].map(s => (
                  <div key={s.label} style={{ background: "var(--bg3)", borderRadius: "var(--radius-sm)", padding: "10px 12px" }}>
                    <div style={{ fontSize: 10, color: "var(--text3)", marginBottom: 3 }}>{s.label}</div>
                    <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 15, color: s.color || "var(--text)" }}>{s.value}</div>
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 12, fontFamily: "var(--font-display)", fontWeight: 600, color: "var(--text3)", marginTop: 4 }}>Recent picks</div>
              {selectedData.recentPicks?.slice(0, 5).map((p, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "9px 0", borderBottom: "1px solid var(--border)", fontSize: 12 }}>
                  <div>
                    <div style={{ fontWeight: 500 }}>{p.homeTeam} vs {p.awayTeam}</div>
                    <div style={{ color: "var(--text3)", fontSize: 11 }}>{p.selection} @ {p.odds}</div>
                  </div>
                  <span className={`pill ${p.result === "won" ? "pill-green" : p.result === "lost" ? "pill-red" : "pill-blue"}`} style={{ fontSize: 10, height: "fit-content" }}>
                    {p.result?.toUpperCase()}
                  </span>
                </div>
              ))}
              <button className="btn btn-primary" style={{ width: "100%" }}>Follow {selectedData.tipster?.name}</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Bookmakers Page ──────────────────────────────────────────────────────────
export function Bookmakers() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch("/bookmakers").then(d => setBooks(d.bookmakers || [])).catch(console.error).finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      <div style={{ background: "rgba(0,229,176,0.05)", border: "1px solid var(--border2)", borderRadius: "var(--radius)", padding: "14px 18px", display: "flex", gap: 14, alignItems: "center" }}>
        <div style={{ fontSize: 22 }}>🇧🇼</div>
        <div>
          <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 14, marginBottom: 3 }}>7 Licensed Botswana Bookmakers</div>
          <div style={{ fontSize: 12, color: "var(--text3)" }}>Odds are scraped directly from each bookmaker's website and updated every 5 minutes. OddsEdge BW is not affiliated with any bookmaker.</div>
        </div>
      </div>

      {loading ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {[...Array(7)].map((_, i) => <div key={i} className="skeleton" style={{ height: 100 }} />)}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {books.map(b => (
            <div className="card" key={b.key} style={{ padding: 0 }}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr auto auto auto", gap: 20, padding: "18px 20px", alignItems: "center" }}>
                <div>
                  <div style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 16 }}>{b.name}</div>
                  <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 3 }}>
                    {b.markets > 0 ? `${b.markets}+ markets` : "No sports markets"} · {b.sports?.join(", ")}
                  </div>
                  {b.notes && <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 6, fontStyle: "italic" }}>{b.notes}</div>}
                  <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
                    {b.sharpFriendly && <span className="pill pill-green" style={{ fontSize: 10 }}>Sharp-friendly</span>}
                    {b.mobileApp && <span className="pill pill-blue" style={{ fontSize: 10 }}>Mobile app</span>}
                  </div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 24, color: b.oddsRating >= 4.5 ? "var(--success)" : b.oddsRating >= 4 ? "var(--accent3)" : "var(--text3)" }}>
                    {b.oddsRating ?? "—"}
                  </div>
                  <div style={{ fontSize: 10, color: "var(--text3)" }}>Odds rating</div>
                </div>
                <div>
                  <span className={`pill ${b.status === "active" ? "pill-green" : "pill-red"}`}>● {b.status}</span>
                </div>
                <a href={b.website} target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ fontSize: 12, padding: "6px 14px" }}>
                  Visit ↗
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


